import keyBy from 'lodash/keyBy';
import { reducer } from 'utils';
import { types } from './listing.actions';

const handlers = {
  [types.FETCH_LISTINGS](state, action) {
    const newState = {
      ...state,
      isFetching: false,
      isFetchingMore: false,
      count: action.listings.count,
      results: Object.assign(state.results || {}, keyBy(action.listings.results, '_id'))
    };

    delete newState.isSearch;

    if (action.isSearch) {
      const newListings = action.listings.results.map(listing => listing._id);
      if (action.isShowMore) {
        newState.searchResults = (state.searchResults || []).concat(newListings);
      } else {
        newState.searchResults = newListings;
      }
    }

    if (action.initial) {
      newState.initial = false;
    }

    return newState;
  },


  [types.FETCH_LISTINGS_REQUEST](state, action) {
    return {
      ...state,
      isFetching: !action.isShowMore,
      isFetchingMore: action.isShowMore,
      initial: action.initial,
      isSearch: action.isSearch,
      skip: action.skip || 0
    }
  },


  [types.QUERY_CHANGE](state, action) {
    const newState = { ...state, query: { ...state.query, ...action.query  }};
    for (const p in newState.query) {
      if (newState.query[p] === null) delete newState.query[p];
    }
    return newState;
  },


  [types.FETCH_LISTING_CALENDAR](state, action) {
    const activeListing = state.activeListing;
    return {
      ...state,
      activeListing: {
        ...activeListing,
        calendar: action.calendar
      }
    }
  },


  [types.FETCH_LISTING_CALENDAR_REQUEST](state, action) {
    const activeListing = state.activeListing;
    return {
      ...state,
      activeListing: {
        ...activeListing,
        calendarRequested: {
          from: action.from,
          to: action.to
        }
      }
    }
  },


  [types.FETCH_SINGLE_LISTING_REQUEST](state, action) {
    const listingId = action.listingId;
    const activeListing = state.activeListing;
    const results = state.results || {};

    return {
      ...state,
      singleInitial: action.initial,
      activeListing: {
        _id: listingId,
        ...results[listingId],
        ...activeListing,
        pending: true
      }
    };
  },


  [types.FETCH_SINGLE_LISTING](state, action) {
    const activeListing = state.activeListing;
    const newState = {
      ...state,
      activeListing: {
        ...activeListing,
        ...action.listing,
        pending: false
      }
    };

    if (action.initial) {
      newState.singleInitial = false;
    }

    return newState;
  },


  [types.SUBMIT_BOOKING](state, action) {
    return { ...state, booked: action.result, booking: false }
  },


  [types.SUBMIT_BOOKING_REQUEST](state, action) {
    return { ...state, booking: true }
  },


  [types.UPDATE_ACTIVE_LISTING](state, action) {
    if (state.activeListing && (state.activeListing._id === action.listingId)) return;

    const listing = state.results && state.results[action.listingId];
    if (listing) {
      return {
        ...state,
        activeListing: state.results[action.listingId]
      }
    }
  },

  [types.RESET_BOOKING](state, action) {
    return {
      ...state,
      booked: undefined,
      booking: false
    };
  }
};

export default reducer(handlers);


// WEBPACK FOOTER //
// ./src/listing/listing.reducer.js